import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import { QUERY_KEYS } from '@/lib/constants';
import type { ApiResponse, ApiKeyPublic } from './types';

export function useKeys() {
  return useQuery({
    queryKey: QUERY_KEYS.keys,
    queryFn: () => api.get<ApiResponse<ApiKeyPublic[]>>('/api/v1/keys'),
    select: (res) => res.data,
  });
}

export function useCreateKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { name: string }) =>
      api.post<ApiResponse<{ key_id: string; plain_key: string }>>('/api/v1/keys', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEYS.keys }),
  });
}

export function useRevokeKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/api/v1/keys/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEYS.keys }),
  });
}
